import { useState } from 'react';
import LeadList from './LeadList';
import Pipeline from './Pipeline';
import ArchivedLeads from './ArchivedLeads';
import NewLeadModal from '../../components/NewLeadModal';
import AgentFilter from '../../components/AgentFilter';
import PipelineValueBar from '../../components/PipelineValueBar';
import Icon from '../../components/Icon';
import { useIsMobile } from '../../hooks/useIsMobile';

// "Leads & Pipeline" — one screen. The view toggle (Table / Kanban / Archive) +
// manager salesman filter sit on the RIGHT next to New lead (T-U3-006). The
// ownerFilter applies to every view. The pipeline value summary (raw + weighted)
// sits above the active views (CRM revisions Task 4).
export default function LeadsPipeline() {
  const [view, setView] = useState('kanban'); // 'kanban' | 'table' | 'archive'
  const [showNew, setShowNew] = useState(false);
  const [ownerFilter, setOwnerFilter] = useState(''); // '' = All team
  const isMobile = useIsMobile();
  // Kanban (wide, drag-and-drop) isn't usable on a phone — fall back to the card list.
  const effView = isMobile && view === 'kanban' ? 'table' : view;
  return (
    <div>
      <div className="toolbar" style={{ marginBottom: 'var(--space-4)' }}>
        <span style={{ flex: 1 }} />
        <AgentFilter value={ownerFilter} onChange={setOwnerFilter} />
        <div className="seg" role="group" aria-label="Leads view">
          <button type="button" className={effView === 'table' ? 'on' : ''} onClick={() => setView('table')}>{isMobile ? 'List' : 'Table'}</button>
          {!isMobile && <button type="button" className={effView === 'kanban' ? 'on' : ''} onClick={() => setView('kanban')}>Kanban</button>}
          <button type="button" className={effView === 'archive' ? 'on' : ''} onClick={() => setView('archive')}>Archive</button>
        </div>
        <button className="btn btn-primary" onClick={() => setShowNew(true)}><Icon name="plus" size={15} /> New lead</button>
      </div>
      {effView !== 'archive' && <PipelineValueBar ownerFilter={ownerFilter} />}
      {effView === 'table' && <LeadList ownerFilter={ownerFilter} />}
      {effView === 'kanban' && <Pipeline ownerFilter={ownerFilter} />}
      {effView === 'archive' && <ArchivedLeads ownerFilter={ownerFilter} />}
      {showNew && <NewLeadModal onClose={() => setShowNew(false)} />}
    </div>
  );
}
